var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ActivitiesRescheduleDatePicker",
    {
      attrs: { value: _vm.activity.date, placement: "bottom-end" },
      on: { "update:value": _vm.updateDueDate }
    },
    [
      _c("CompassButton", {
        attrs: {
          label: _vm.$t.__("common.actions.reschedule"),
          loading: _vm.isReschedulePending,
          leftIcon: "calendar-reschedule",
          type: "secondary"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }